import {getMessage} from '../../components';

export default (messages) => {
    return {
        eventName: {
            identifier: 'eventName',
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.event_name')
            }
        },
        eventOrg: {
            identifier: 'eventOrg',
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.event_organizer')
            }
        },
        eventDate: {
            identifier: 'eventDate',
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.event_date')
            }
        },
        firstName: {
            identifier: 'firstName',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.first_name')
            }
        },
        lastName: {
            identifier: 'lastName',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.last_name')
            }
        },
        emailAddress: {
            identifier: 'email',
            validations: {
                isEmail: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isEmail: getMessage(messages, 'errors.epic.validation.email')
            },
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.email')
            }
        },
        birthDay: {
            identifier: 'dateOfBirth',
            display: {
                text: `${getMessage(messages, 'epic.esport.participation.legal.form.date_of_birth')} (${getMessage(messages, 'epic.esport.participation.legal.form.date.getter.15')})`
            }
        },
        age: {
            identifier: 'age',
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.age')
            }
        },
        signature: {
            identifier: 'signature',
            validations: {
                isValidSignature: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isValidSignature: getMessage(messages, 'errors.com.epicgames.ecommerce.payout.participation_form.invalid_signature')
            },
            display: {
                text: getMessage(messages, 'epic.esport.participation.form.signature.label')
            }
        },
        playerLastName: {
            identifier: 'playerLastName',
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.last_name')
            }
        },
        signatureDate: {
            identifier: 'signatureDate',
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.date_signed')
            }
        },
        relationship: {
            identifier: 'relationship',
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.relationship_to_player')
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            optionLabel: {
                parent: getMessage(messages, 'epic.esport.participation.form.relationship.parent'),
                guardian: getMessage(messages, 'epic.esport.participation.form.relationship.legal_guardian')
            }
        },
        guardianFirstName: {
            identifier: 'guardianFirstName',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.first_name')
            }
        },
        guardianLastName: {
            identifier: 'guardianLastName',
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required')
            },
            display: {
                text: getMessage(messages, 'epic.esport.participation.legal.form.last_name')
            }
        },
        guardianSignature: {
            identifier: 'guardianSignature',
            validations: {
                isValidGuardianSignature: true
            },
            validationMessages: {
                isDefaultRequiredValue: getMessage(messages, 'errors.epic.validation.required'),
                isValidGuardianSignature: getMessage(messages, 'errors.com.epicgames.ecommerce.payout.participation_form.invalid_guardian_signature')
            },
            display: {
                text: getMessage(messages, 'epic.esport.participation.form.signature.label')
            }
        }
    };
};
